import Icon from '@material-ui/icons/Dashboard'

export default {
  icon: Icon,
}
